import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ContentLoaderComponent } from './content-loader.component';

@NgModule({
  declarations: [ContentLoaderComponent],
  imports: [CommonModule, MatProgressSpinnerModule],
  exports: [ContentLoaderComponent],
})
export class ContentLoaderModule {}
